import { Auth, IAuthenticatedUser } from '../Services/AuthenticationService';
import { EventHandlerProvider } from '../Services/EventHandlerService';
import { VeriLiteErrorEvent, IVeriLiteEvent, IResources } from '../Types';

export function saysWho() {
    const userAgent = navigator.userAgent;
    let tem;
    let userAgentMatch = userAgent.match(/(opera|chrome|safari|firefox|msie|trident(?=\/))\/?\s*(\d+)/i) || [];

    if (/trident/i.test(userAgentMatch[1])) {
        tem = /\brv[ :]+(\d+)/g.exec(userAgent) || [];
        return { name: "IE", version: (tem[1] || "") };
        //return `IE ${tem[1] || ""}`;
    }

    if (userAgentMatch[1] === "Chrome") {
        tem = userAgent.match(/\b(OPR|Edge)\/(\d+)/);
        //if (tem != null) return tem.slice(1).join(" ").replace("OPR", "Opera");
        if (tem !== null) return { name: tem[1].replace("OPR", "Opera"), version: tem[2] };
    }

    userAgentMatch = userAgentMatch[2] ? [userAgentMatch[1], userAgentMatch[2]] : [navigator.appName, navigator.appVersion, "-?"];
    if ((tem = userAgent.match(/version\/(\d+)/i)) !== null) userAgentMatch.splice(1, 1, tem[1]);

    //return userAgentMatch.join(" ");
    const [name, version] = userAgentMatch;
    return { name, version };
}

export function getQuery(params:any) {
    return Object.keys(params)
        .map(k => encodeURIComponent(k) + '=' + encodeURIComponent(params[k]))
        .join('&');
}

export async function getJson1(url:string, options:any, useAuthentication : boolean = true) {

    const headers = new Headers();
    headers.append("pragma", "no-cache");
    headers.append("cache-control", "no-cache");
    headers.append("accept", "application/json, application/xml, text/plain, text/html, *.*");
    headers.append("content-type", "application/json;");
    headers.append("Access-Control-Allow-Origin", "*");
    
    if (useAuthentication) {
        await Auth.getAccessToken().then((token) => {
            headers.append("Authorization", `Bearer ${token}`);
            options.headers = headers;
        }).catch((error) => {
            console.error(`Error adding auth header: ${error}`);
        });
    }

    const defaultOptions = {
        credentials: "include",
        method: "GET",
        headers: headers,
        mode: "cors",
        redirect: "follow",
        body: null
    };
    options = Object.assign(defaultOptions, options);
    return new Promise((resolve, reject) => {
        fetch(url, options).then(resp => {
            resp.json().then(data => {
                resp.ok ? resolve(data) : reject(data);
            }).catch((e) => {
                reject(e);
            });
        }).catch((er) => {
            reject(er);
        });
    });
}

export async function getJson2(url: string, options: RequestInit, useAuthentication : boolean = true): Promise<any> {
    const headers = new Headers();
    headers.append("pragma", "no-cache");
    headers.append("cache-control", "no-cache");
    headers.append("accept", "application/json, application/xml, text/plain, text/html, *.*");
    headers.append("content-type", "application/json;");
    headers.append("Access-Control-Allow-Origin", "*");

    if (useAuthentication) {
        await Auth.getAccessToken().then((token) => {
            headers.append("Authorization", `Bearer ${token}`);
            options.headers = headers;
        }).catch((error) => {
            console.error(`Error adding auth header: ${error}`);
        });
    }
    const defaultOptions = {
        credentials: "include",
        method: "GET",
        headers: headers,
        mode: "cors",
        redirect: "follow",
        body: null
    };
    options = Object.assign(defaultOptions, options);
    return fetch(url, options)
        .then((response: any) => {
            return response.json();
        })
        .catch(reason => console.error("Error loading " + url + ". With reason: " + reason));
}

const defaultHeaders: Headers = new Headers({
    "pragma": "no-cache",
    "cache-control": "no-cache",
    "accept": "application/json, application/xml, text/plain, text/html, *.*",
    "content-type": "application/json;",
    "Access-Control-Allow-Origin": "*"
});

const defaultGetOptions: RequestInit = {
    credentials: "include",
    method: "GET",
    headers: defaultHeaders,
    mode: "cors",
    redirect: "follow",
    body: null
};

export const defaultPostOptions: RequestInit = {
    credentials: "include",
    method: "POST",
    headers: defaultHeaders,
    mode: "cors",
    redirect: "follow",
    body: null
};

export const defaultDeleteOptions: RequestInit = {
    credentials: "include",
    method: "DELETE",
    headers: defaultHeaders,
    mode: "cors",
    redirect: "follow",
    body: null
};

export class UserRequestHeaders {
    public Organisation: string;
    public Location: string;
    public UserId: string;
    public static OrganisationKey: string = "verilite-organisation";
    public static LocationKey: string = "verilite-location";
    public static UserIdKey: string = "verilite-userid";
    constructor(user: any) {
        this.Organisation = user.Organisation;
        this.Location = user.Location;
        this.UserId = user.id;
    }
    public AppendHeaders(options: RequestInit): void {
        var headers = new Headers(options.headers);
        headers.append(UserRequestHeaders.OrganisationKey, encodeURI(this.Organisation));
        headers.append(UserRequestHeaders.LocationKey, encodeURI(this.Location));
        headers.append(UserRequestHeaders.UserIdKey, this.UserId);
        options.headers = headers
    }
}

export class TransactionIdRequestHeader {
    public TransactionId: string
    public static TransactionIdKey: string = "Transaction-Id";
    constructor(id: string) {
        this.TransactionId = id;
    }
}

export async function postJson(url: string, body: string, options: RequestInit = defaultPostOptions, useAuthentication: boolean = true, userRequestHeaders: UserRequestHeaders | undefined = undefined, manuallyHandleError: boolean = false, transactionIdRequestHeader: TransactionIdRequestHeader|undefined = undefined, ignoreUserHeader = false): Promise<any> {
    options = Object.assign({ ...defaultPostOptions }, options);

    options = { ...options, body: body };

    if (useAuthentication) {
        await Auth.getAccessToken().then((token) => {
            var headers = new Headers(options.headers);
            headers.append("Authorization", `Bearer ${token}`);
            options.headers = headers;
        }).catch((error) => {
            console.error(`Error adding auth header: ${error}`);
        });
    }

    if (!ignoreUserHeader){
        var userRequestHeader = new UserRequestHeaders(Auth.getUser());
        if (userRequestHeader != undefined) {
            userRequestHeader.AppendHeaders(options);
        }
    }

    if (transactionIdRequestHeader != undefined) {
        var headers = new Headers(options.headers);
        headers.append(TransactionIdRequestHeader.TransactionIdKey, transactionIdRequestHeader.TransactionId);
        options.headers = headers;
    }

    return fetch(url, options)
        .then((response: Response) => {
            //console.log(response)
            if (!response.ok) {
                //console.log(response.status)
                if (response.status === 401 || response.status === 403) {
                    throw window.resources.SorryWeWereUnableToMakeYourRequest;
                }
                else if (response.status == 400) {
                    return new Promise<any>((resolve, reject) => {
                        response.json().then(json => {
                            //console.log(json)
                            reject(json);
                        }).catch(e => {
                            console.error(e)
                            throw e;
                        });
                    });
                }
                else {
                    throw window.resources.SomethingWentWrongContact;
                }
            }
            else {
                //console.log("postJsonResponse")
                //console.log(response.body)
                
                return response.json().then(json => {
                    //console.log("then")
                    return new Promise<any>((resolve) => resolve(json));
                }).catch(e => {
                    //console.log("catch")
                    return new Promise<any>((resolve) => resolve(true));
                });
            }
        })
        .catch((reason) => {
            //console.log(`hit catch: ${reason}`)
            console.error(reason)
            if (manuallyHandleError) {
                return new Promise<string>((resolve, reject) => reject(reason));
            } else{
                EventHandlerProvider.GetInstance().AddEvent(new VeriLiteErrorEvent(reason));
                return new Promise<string>((resolve) => resolve(""));
            }
            
        });
}

export async function getJson(url: string, options: RequestInit = defaultGetOptions, useAuthentication: boolean = true, userRequestHeaders: UserRequestHeaders | undefined = undefined): Promise<any> {

    options = Object.assign({ ...defaultGetOptions }, options);

    if (useAuthentication) {
        await Auth.getAccessToken().then((token) => {
            var headers = new Headers(options.headers);
            headers.append("Authorization", `Bearer ${token}`);
            options.headers = headers;
        }).catch((error) => {
            console.error(`Error adding auth header: ${error}`);
        });
    }

    if (userRequestHeaders != undefined) {
        userRequestHeaders.AppendHeaders(options);
    }
        
    return fetch(url, options)
        .then((response: Response) => {
            if (!response.ok) {
                if (response.status === 401 || response.status === 403) {
                    throw window.resources.SorryWeWereUnableToMakeYourRequest;
                }
                else {
                    throw window.resources.SomethingWentWrongContact;
                }                
            }
            else {
                if (response.status !== 204) {
                    return response.json();
                } else {
                    return null;
                }
            }
        })
        .catch((reason) => {
            var actions = VeriLiteErrorEvent.DefaultActions(window.resources);
            actions[0].callback = (currentEvent: IVeriLiteEvent, closeModalCallback: () => void) => {
                //todo error reports
                console.error(`Error calling ${url} with reason: ${reason}`);
                closeModalCallback();
            }
            EventHandlerProvider.GetInstance().AddEvent(new VeriLiteErrorEvent(reason?.message || reason, undefined, ));
            return new Promise<string>((resolve)=> resolve(JSON.stringify("")));
        });
}

export function copyText(textToCopy:string) {
    const textArea = document.createElement("textarea");
    textArea.value = textToCopy;
    textArea.style.position = "absolute";
    textArea.style.height = "0";
    textArea.style.width = "0";
    textArea.style.opacity = "0";
    document.body.appendChild(textArea);
    textArea.select();
    document.execCommand("copy");
    document.body.removeChild(textArea);
}

export function isNullOrWhiteSpace(str: string|undefined): boolean {
    return str == undefined || str === null || str.length < 1 || str.match(/^ *$/) !== null;
}

export function convertExpiryDate(stringDate: string): string {
    if (isNullOrWhiteSpace(stringDate)) {
        return "";
    }
    try {
        var day = +stringDate.substring(4, 6);
        var month = +stringDate.substring(2, 4) - (day > 0 ? 1 : 0);
        var year = +`${new Date().getFullYear().toString().substring(0, 2)}${stringDate.substring(0, 2)}`;
        var date = new Date(year, month, day);
        var offset = date.getTimezoneOffset();
        var d = new Date(date.getTime() - (offset * 60000));
        var IsoDate = d.toISOString();
        var result = IsoDate.substring(0, 10);
        return result;
    }
    catch(e) {
        return `Invalid Expiry Date: ${stringDate}`;
    }
}

export function parseBoolean(input: any): boolean {
    switch (input) {
        case true:
        case "true":
        case "True":
        case "TRUE":
        case 1:
        case "1":
        case "on":
        case "On":
        case "ON":
        case "yes":
        case "Yes":
        case "YES":
            return true;
        default:
            return false;
    }
}

export function getValueFromInputRef<T extends HTMLInputElement>(ref: React.RefObject<T>) {
    return ref.current ? ref.current.value.trim() : "";
}

export function getNameFromInputRef<T extends HTMLInputElement>(ref: React.RefObject<T>) {
    return ref.current ? ref.current.name : "";
}

export function stringifyEvent(e: any) {
    const obj: any = {};
    for (let k in e) {
        obj[k] = e[k];
    }
    return JSON.stringify(obj, (k, v) => {
        if (v instanceof Node) return 'Node';
        if (v instanceof Window) return 'Window';
        return v;
    }, ' ');
}

export function GetResources(callback: (resources: IResources) => void) {
    setTimeout(() => {
        if (window.resources == undefined) {
            GetResources(callback);
        }
        else {
            callback(window.resources);
        }
    }, 100);
};